<template>
  <footer class="app-footer">Apostilla - Ministerio de Relaciones Exteriores {{ year }}</footer>
</template>

<script>
export default {
  computed: {
    year () {
      let date = new Date();
      return date.getFullYear();
    }
  }
};
</script>

<style lang="scss">
.app-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  font-size: .75rem;
  padding: 5px 10px;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.6);
}
@media (max-width: 768px) {
  .app-footer {
    position: static;
    margin: 10px 0;
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/AppFooter.vue